
import { Button } from "@/components/ui/button";
import { CheckCircle } from "lucide-react";
import { AssessmentQuestion } from "./types";
import { useNavigate } from "react-router-dom";

interface CompletionScreenProps {
  question: AssessmentQuestion;
  onFinish: () => void;
  scoreIncrease?: number;
}

export function CompletionScreen({ question, onFinish, scoreIncrease = 15 }: CompletionScreenProps) {
  const navigate = useNavigate();

  return (
    <div className="text-center space-y-8 py-8 w-full max-w-4xl mx-auto min-h-[400px] flex flex-col justify-center">
      <div className="space-y-4">
        <p className="text-lg text-muted-foreground max-w-lg mx-auto">
          Thanks for sharing your perspective — you've just moved the needle.
        </p>
        <p className="text-lg text-muted-foreground max-w-lg mx-auto">
          Your mySuccession score has <span className="text-primary font-semibold">increased by {scoreIncrease}%</span>. That shift reflects the clarity you brought to your answers and gives us a stronger foundation to map out your next steps with confidence.
        </p>
      </div>
      
      <div className="flex gap-4 justify-center">
        <Button 
          size="sm" 
          onClick={onFinish} 
          variant="outline"
          className="px-4 py-2 h-auto text-sm"
        >
          Close Survey
        </Button>
        <Button 
          size="sm" 
          onClick={() => navigate("/dashboard")}
          className="bg-accent hover:bg-accent/90 text-accent-foreground px-4 py-2 h-auto text-sm"
        >
          Go to Dashboard
        </Button>
      </div>
    </div>
  );
}
